/**
 * Custom SVG icon set — original artwork, no third-party IP.
 * Style: brutalist ink strokes, matches the manga editorial theme.
 */

export function JollyRoger({ size = 40, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="32" cy="26" r="16" fill="currentColor" opacity="0.08" />
            <path d="M20 22c0-6 5-11 12-11s12 5 12 11c0 4-2 7-5 9v6l-3 2h-8l-3-2v-6c-3-2-5-5-5-9z" />
            <circle cx="26" cy="26" r="3" fill="currentColor" />
            <circle cx="38" cy="26" r="3" fill="currentColor" />
            <path d="M28 34l-2 3M36 34l2 3M28 38h8" />
            {/* crossed bones */}
            <path d="M14 50l36-16M14 34l36 16" strokeWidth="4" />
            <circle cx="12" cy="52" r="3" fill="currentColor" />
            <circle cx="52" cy="52" r="3" fill="currentColor" />
            <circle cx="12" cy="32" r="3" fill="currentColor" />
            <circle cx="52" cy="32" r="3" fill="currentColor" />
        </svg>
    );
}

export function TreasureChest({ size = 40, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M8 30h48v22H8z" />
            <path d="M8 30c0-8 6-14 24-14s24 6 24 14" />
            <rect x="26" y="34" width="12" height="10" strokeWidth="3" />
            <circle cx="32" cy="39" r="1.5" fill="currentColor" />
            <path d="M8 40h48M16 30v-3M48 30v-3" />
            <path d="M4 52h56" strokeWidth="4" />
        </svg>
    );
}

export function LogPose({ size = 40, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="32" cy="32" r="20" />
            <circle cx="32" cy="32" r="14" strokeDasharray="2 3" />
            <path d="M32 18v6M32 40v6M18 32h6M40 32h6" />
            {/* compass needle */}
            <path
                d="M32 22l4 10-4 10-4-10z"
                fill="currentColor"
                opacity="0.8"
            />
            <circle cx="32" cy="32" r="2" fill="currentColor" />
        </svg>
    );
}

export function WantedPoster({ size = 40, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 8h40v48H12z" />
            <path d="M18 14h28" strokeWidth="4" />
            <path
                d="M22 22h20v18H22z"
                fill="currentColor"
                opacity="0.15"
            />
            <path d="M18 46h28M18 51h20" />
            <circle cx="20" cy="10" r="2" fill="currentColor" />
            <circle cx="44" cy="10" r="2" fill="currentColor" />
            <circle cx="20" cy="54" r="2" fill="currentColor" />
            <circle cx="44" cy="54" r="2" fill="currentColor" />
        </svg>
    );
}

export function CaptainWheel({ size = 40, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="32" cy="32" r="14" />
            <circle cx="32" cy="32" r="4" fill="currentColor" />
            {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, i) => (
                <g key={i} transform={`rotate(${deg} 32 32)`}>
                    <path d="M32 18v-8" strokeWidth="3" />
                    <circle cx="32" cy="8" r="3" fill="currentColor" />
                </g>
            ))}
        </svg>
    );
}

export function GrandRoute({ size = 40, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M8 48s6-24 24-24 24-16 24-16" strokeDasharray="3 3" />
            <circle cx="8" cy="48" r="3" fill="currentColor" />
            <path d="M32 24l-3 5h6z" fill="currentColor" />
            <circle cx="32" cy="24" r="6" strokeWidth="2" />
            <path d="M56 8l-3-2 3-3 3 3z" fill="currentColor" />
            <path d="M50 42l3 6M46 46l3 6M42 38l3 6" strokeWidth="2" />
        </svg>
    );
}
